(function () {
  if (window.PopsResponsiveVideo) {
    window.PopsResponsiveVideo.sync();
    return;
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function syncVideo(wrapper) {
    var video = wrapper.querySelector('video');
    var breakpoint = parseInt(wrapper.dataset.popsVideoBreakpoint, 10);
    var variant = wrapper.dataset.popsVideoVariant;

    if (!video || Number.isNaN(breakpoint)) {
      return;
    }

    var desktopMatches = window.matchMedia('(min-width: ' + breakpoint + 'px)').matches;
    var isActive = variant === (desktopMatches ? 'desktop' : 'mobile');

    if (!isActive || reducedMotion.matches) {
      video.pause();
      return;
    }

    if (video.preload === 'none') {
      video.preload = 'metadata';
      video.load();
    }

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function sync(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-pops-video-variant]').forEach(syncVideo);
  }

  window.PopsResponsiveVideo = { sync: sync };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      sync();
    });
  } else {
    sync();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      sync();
    }, 150);
  });

  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', function () {
      sync();
    });
  } else if (typeof reducedMotion.addListener === 'function') {
    reducedMotion.addListener(function () {
      sync();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    sync(event.target);
  });
})();
